import { observable } from 'mobx';
import { UiResponse } from '../CommonInterfaces';
import RootStore from './RootStore';
import BaseLoginStore from './BaseLoginStore';

export interface DealerLoginCredentials {
  username: string;
  password: string;
}

export default class DealerLoginStore extends BaseLoginStore {
  @observable accessor dealerLoginCredentials: DealerLoginCredentials = { username: '', password: '' };

  constructor(rootStore: RootStore) {
    super(rootStore);
  }

  public handleLogin = async () => {
    await this.handleLoginTemplate('/admin/auth', this.dealerLoginCredentials);
  };

  public customLogin = (): Promise<UiResponse | null> => {
    return this.loginWithoutMainFlow('/admin/auth', this.dealerLoginCredentials, undefined);
  };
}
